import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bee5803"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sw-process-navigation--items" }

import { ColorType, IconType } from '@/types/ui-components';
import {
  computed,
  withDefaults,
  ref,
} from 'vue';
import SwTextButton from '@/components/molecules/Buttons/SwTextButton.vue';
import { Forms } from '@/api/spotwrite';

interface Emits {
  (e: 'update:modelValue', data: Forms): void;
}

interface Props {
  items?: Forms[];
  color?: ColorType;
  modelValue?: Forms;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwProcessNavigation',
  props: {
    items: { default: undefined },
    color: { default: 'primary' },
    modelValue: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', data: Forms): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: Forms[], color: ColorType, modelValue: Forms }



const defaultProcess = ref<Forms>({
  id: 0,
  title: 'すべての工程',
  createdAt: undefined,
  updatedAt: undefined,
  productions: [],
});
/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-process-navigation': true,
  [`sw-process-navigation--${props.color || 'primary'}`]: true,
}));

/**
 * アイコンを取得
 * @param form
 */
const getIconType = (form: Forms): IconType | undefined => {
  switch (form.id) {
    case 0:
      return 'sw-icon-all';
    case 1:
      return 'sw-icon-script';
    case 2:
      return 'sw-icon-drawing';
    case 3:
      return 'sw-icon-storyboard';
    case 4:
      return 'sw-icon-paint';
    default:
      return undefined;
  }
};

/**
 * アクティブなアイテムかどうか
 * @param item
 */
const isActive = (item?: Forms) => {
  if (!props.modelValue && item && item.id === 0) {
    return true;
  }
  return item && props.modelValue ? item.id === props.modelValue.id : false;
};

/**
 * アイテムの class 属性
 */
const getItemClasses = (item?: Forms) => ({
  'sw-process-navigation--items-item': true,
  active: isActive(item),
});


/**
 * アイテムクリック時
 * @param item
 */
const onClickItem = (item: Forms) => {
  emit('update:modelValue', item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", {
          class: _normalizeClass(getItemClasses(defaultProcess.value))
        }, [
          _createVNode(SwTextButton, {
            label: (defaultProcess.value.title as string),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickItem(defaultProcess.value))),
            color: "gray",
            size: "large",
            icon: getIconType(defaultProcess.value)
          }, null, 8, ["label", "icon"])
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: _normalizeClass(getItemClasses(item))
          }, [
            _createVNode(SwTextButton, {
              label: (item.title as string),
              onClick: ($event: any) => (onClickItem(item)),
              color: "gray",
              size: "large",
              icon: getIconType(item)
            }, null, 8, ["label", "onClick", "icon"])
          ], 2))
        }), 128))
      ])
    ])
  ], 2))
}
}

})